import "./src/styles/global.scss"

export const onClientEntry = () => {
  window.__onThemeChange = () => {}

  let preferredTheme
  try {
    preferredTheme = localStorage.getItem('theme')
  } catch (e) {}

  const setTheme = (newTheme) => {
    window.__theme = newTheme
    preferredTheme = newTheme
    document.body.className = newTheme
    window.__onThemeChange(newTheme)
  }

  window.__setPreferredTheme = (newTheme) => {
    setTheme(newTheme)
    try {
      localStorage.setItem('theme', newTheme)
    } catch (e) {}
  }

  const darkQuery = window.matchMedia('(prefers-color-scheme: dark)')
  darkQuery.addListener((e) => {
    window.__setPreferredTheme(e.matches ? 'dark' : 'light')
  })

  setTheme(preferredTheme || (darkQuery.matches ? 'dark' : 'light'))
}